// extracted by mini-css-extract-plugin
module.exports = {"main-component":"userProfile_main-component__34m0x"};